<template>
  <div class="block block-rounded border-left border-3x" :class="[{ 'border-danger': getAccountFrom === account }, { 'border-success': getAccountTo === account }]">
    <div class="block-content block-content-full d-flex align-items-center justify-content-between pb-1">
      <div>
        <p class="font-size-lg font-w600 mb-0">
          {{ transfer._quantity}} {{ transfer._symbol }}
        </p>
        <p v-if="getAccountFrom !== account" class="mb-0">
          <span class="text-muted">{{$t('common.transferDetails.receivedFrom')}} </span><a :href="blockExplorerLink() + getAccountFrom" target="_blank" v-text="getAccountFrom"></a><span v-if="transfer._count"> - <span class="text-muted">{{$t('common.transferDetails.txCount')}} </span><span v-text="transfer._count"></span></span>
        </p>
        <p v-else class="mb-0">
          <span class="text-muted">{{$t('common.transferDetails.sentTo')}} </span><a :href="blockExplorerLink() + getAccountTo" target="_blank" v-text="getAccountTo"></a><span v-if="transfer._count"> - <span class="text-muted">{{$t('common.transferDetails.txCount')}} </span><span v-text="transfer._count"></span></span>
        </p>
      </div>
      <div class="ml-3">
        <font-awesome-icon v-if="getAccountFrom === account"  icon="arrow-right" class="fa-2x text-danger"/>
        <font-awesome-icon v-else icon="arrow-left" class="fa-2x text-success"/>
      </div>
    </div>
    <div class="block-content block-content-full block-content-sm mt-0 pt-0">
      <div class="progress mb-1" style="height: 6px;">
        <div class="progress-bar" :class="[{ 'bg-danger': getAccountFrom === account }, { 'bg-success': getAccountTo === account }]" role="progressbar" :style="'width: ' + getPercentage(transfer._quantity) + '%;'" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </div>
    <div v-if="!transfer._count" class="block-content block-content-full block-content-sm bg-body-light">
      <span class="font-size-sm text-muted">{{$t('common.transferDetails.txId')}} <a :href="blockExplorerLink('tx') + transfer._trxId" target="_blank">{{ transfer._trxId.substring(0, 6)}}</a> - <strong v-text="moment(transfer._time).format('MMM Do YYYY - h:mm:ss a')"></strong></span><span v-if="transfer._memo" v-b-popover.hover.top="transfer._memo"> - Memo</span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import numbro from 'numbro'

export default {
  props: ['transfer', 'account'],
  name: 'TransferDetails',
  data () {
    return {
      moment: moment,
      numbro: numbro
    }
  },
  computed: {
    modal () {
      return this.$store.state.network.modal
    },
    getAccountFrom () {
      return this.transfer._from._name.split('/')[1]
    },
    getAccountTo () {
      return this.transfer._to._name.split('/')[1]
    },
    selectedChain () {
      return this.$store.state.options.selectedChain
    }
  },
  methods: {
    getPercentage (quantity) {
      const total = this.modal.data.transfers[0]._quantity
      let percentage = ((quantity - total) / total * 100) + 100
      if (percentage <= 0.5) {
        percentage = 0.5
      }
      return percentage
    },
    blockExplorerLink (type = 'account') {
      const chain = this.selectedChain === 'eos' ? '' : this.selectedChain + '.'
      return 'https://' + chain + 'eosx.io/' + type + '/'
    }
  }
}
</script>

<style scoped>
  .progress {
    background-color: #ffffff;
  }
  .progress-bar {
    border-radius: 4px;
  }
</style>
